import { Avatar } from '@radix-ui/themes';
import * as React from 'react';
import { userImageSrc, userInitials } from 'src/lib/helpers';

interface IProps {
  user: Odoo.User;
  size?: React.ComponentProps<typeof Avatar>['size'];
}

const UserAvatar: React.FC<IProps> = ({ user, size }) => {
  return (
    <Avatar
      className="user-avatar"
      src={userImageSrc(user)}
      fallback={userInitials(user.display_name)}
      size={size}
    />
  );
};

export default UserAvatar;
